import { render, staticRenderFns } from "./EditCategoryDialog.vue?vue&type=template&id=19f37865&scoped=true&"
import script from "./EditCategoryDialog.vue?vue&type=script&lang=ts&"
export * from "./EditCategoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f37865",
  null
  
)

export default component.exports